import $ from 'jquery';

export default function productFilterModule() {
  const productFilterElement = $('.related-products');
  if (productFilterElement.length) {
    return import(/* webpackChunkName: "product-filter" */ '../productFilter')
      .then(({ default: ProductFilter }) => {
        const productFilter = new ProductFilter();
        return productFilter;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
